<div class="payment-details-main-container" style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: flex-start; justify-content: center;">

  <div style="display: flex !important; display: flex; align-items: center !important; justify-content: right !important;
    height:fit-content !important; width:100% !important; padding:20px 20px 0px 20px"
    (click)="onGoBack()">
      <img [src]="'assets/icons/crossClose.svg'">
    </div>

  <div class=" bold-20px-center-primary" style="width: 100%; display: flex; align-items: center; justify-content: center;">
    <span> {{headTitle}} </span>
  </div>
  <div>
  <div class="payment-details-content" style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: flex-start; justify-content: flex-start;">
    <div class="payment-details-date light-14px-center-primary" style="width: 100%; display: flex; align-items: center; justify-content: center;">
      {{data.transaction.createdAt | date : 'dd-MM-yyyy HH:mm'}}
    </div>
    @if (data.extraInfo !== undefined) {
      <div class="payment-details-date light-14px-center-primary" style="width: 100%; display: flex; align-items: center; justify-content: center;">
        {{ 'payments.gg' | translate}} {{fullPay}}
      </div>
    }
    @if (data.extraInfo !== undefined) {
      <div class="payment-details-date light-14px-center-primary" style="width: 100%; display: flex; align-items: center; justify-content: center;">
        {{ 'payments.method' | translate}} {{paymentMethod}}
      </div>
    }

    <!--PAGO CON BONOS-->
    <!--<div class="payment-details-headers" style="width: 100%; display: flex; align-items: center; justify-content: center;">-->
    <!--<div class="light-16px-left-primary" style="width: 50%;">Bono</div>-->
    <!--<div class="light-16px-right-primary" style="width: 50%;">Fichas usadas</div>-->
    <!--</div>-->

    <!--<div class="payment-details-content-background primary-background-50" style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap;"-->
    <!--style="display: flex; align-items: flex-start; justify-content: center;"-->
    <!--[ngStyle]="{'height.px' : payment.vouchers * 40 + 20}">-->
    <!--&lt;!&ndash;ng for por cada bono usado o recargado&ndash;&gt;-->
    <!--<div class="payment-details-boucher" style="width: 100%; display: flex; align-items: center; justify-content: center;">-->
    <!--<div class="payment-details-boucher-name bold-400-18px-left-primary" style="width: 40%;">Happy Hour</div>-->
    <!--&lt;!&ndash;<div class="payment-details-boucher-quantity bold-400-18px-left-primary">6</div>&ndash;&gt;-->
    <!--<div class="payment-details-boucher-tokens" style="width: 60%;">-->
    <!--<div class="voucher-uses-row" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 14px; display: flex; align-items: center; justify-content: flex-end;">-->
    <!--&lt;!&ndash;ngFor icono por cada uso disponible&ndash;&gt;-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="payment-details-boucher" style="width: 100%; display: flex; align-items: center; justify-content: center;">-->
    <!--<div class="payment-details-boucher-name bold-400-18px-left-primary" style="width: 40%;">Plato de arroz</div>-->
    <!--&lt;!&ndash;<div class="payment-details-boucher-quantity bold-400-18px-left-primary">6</div>&ndash;&gt;-->
    <!--<div class="payment-details-boucher-tokens" style="width: 60%;">-->
    <!--<div class="voucher-uses-row" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 14px; display: flex; align-items: center; justify-content: flex-end;">-->
    <!--&lt;!&ndash;ngFor icono por cada uso disponible&ndash;&gt;-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->


    <!--<div class="payment-details-boucher" style="width: 100%; display: flex; align-items: center; justify-content: center;">-->
    <!--<div class="payment-details-boucher-name bold-400-18px-left-primary" style="width: 40%;">Plato de arroz</div>-->
    <!--&lt;!&ndash;<div class="payment-details-boucher-quantity bold-400-18px-left-primary">6</div>&ndash;&gt;-->
    <!--<div class="payment-details-boucher-tokens" style="width: 60%;">-->
    <!--<div class="voucher-uses-row" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 14px; display: flex; align-items: center; justify-content: flex-end;">-->
    <!--&lt;!&ndash;ngFor icono por cada uso disponible&ndash;&gt;-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="payment-details-boucher" style="width: 100%; display: flex; align-items: center; justify-content: center;">-->
    <!--<div class="payment-details-boucher-name bold-400-18px-left-primary" style="width: 40%;">Plato de arroz</div>-->
    <!--&lt;!&ndash;<div class="payment-details-boucher-quantity bold-400-18px-left-primary">6</div>&ndash;&gt;-->
    <!--<div class="payment-details-boucher-tokens" style="width: 60%;">-->
    <!--<div class="voucher-uses-row" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 14px; display: flex; align-items: center; justify-content: flex-end;">-->
    <!--&lt;!&ndash;ngFor icono por cada uso disponible&ndash;&gt;-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="payment-details-boucher" style="width: 100%; display: flex; align-items: center; justify-content: center;">-->
    <!--<div class="payment-details-boucher-name bold-400-18px-left-primary" style="width: 40%;">Plato de arroz</div>-->
    <!--&lt;!&ndash;<div class="payment-details-boucher-quantity bold-400-18px-left-primary">6</div>&ndash;&gt;-->
    <!--<div class="payment-details-boucher-tokens" style="width: 60%;">-->
    <!--<div class="voucher-uses-row" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 14px; display: flex; align-items: center; justify-content: flex-end;">-->
    <!--&lt;!&ndash;ngFor icono por cada uso disponible&ndash;&gt;-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="payment-details-boucher" style="width: 100%; display: flex; align-items: center; justify-content: center;">-->
    <!--<div class="payment-details-boucher-name bold-400-18px-left-primary" style="width: 40%;">Plato de arroz</div>-->
    <!--&lt;!&ndash;<div class="payment-details-boucher-quantity bold-400-18px-left-primary">6</div>&ndash;&gt;-->
    <!--<div class="payment-details-boucher-tokens" style="width: 60%;">-->
    <!--<div class="voucher-uses-row" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 14px; display: flex; align-items: center; justify-content: flex-end;">-->
    <!--&lt;!&ndash;ngFor icono por cada uso disponible&ndash;&gt;-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--<img [src]="'assets/bracelit/voucher_use_full.svg'" alt="">-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->

    <!--<div class="regular-18px-center-primary close-dialog" style="width: 100%; display: flex; align-items: center; justify-content: center;"-->
    <!--(click)="onGoBack()">-->
    <!--Volver-->
    <!--</div>-->

    <!--</div>-->

    <!--PAGO CON BRACELS O COMPRA DE BRACELS-->

    <div [ngStyle]="{'height.px' : 40}" class="payment-details-content-background primary-background-50" style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: flex-start; justify-content: center; background-color:white !important">
      <div class="payment-details-boucher " style="width: 100%; display: flex; align-items: center; justify-content: center;">
        @if (coinName === 'bracels' || coinName === 'Bracels') {
          <div class="payment-details-boucher-quantity bold-400-18px-center-primary"
               style="width: 100%; display: flex; align-items: center; justify-content: center;">
            {{wordShop}}: {{infoQuantity}}
            <img style="width: 20px !important; height: 20px !important; display: flex; align-items: center; margin:0px !important" [src]="'assets/icons/moneda.svg'" alt="">
          </div>
        }
        @if (coinName !== 'bracels' && coinName !== 'Bracels') {
          <div class="payment-details-boucher-quantity bold-400-18px-center-primary"
               style="width: 100%; display: flex; align-items: center; justify-content: center;">
               {{ 'payments.quantity' | translate}} {{data.transaction.amount}} <img [src]="'https://' + domain + 'api/v1/files/' + eventId + '/downloadCoin'" alt="">
          </div>
        }
      </div>
    </div>

    @if (linesInfo) {
      <div [ngStyle]="{'height.px' : 40}" class="payment-details-content-background primary-background-50" style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap; display: flex; align-items: flex-start; justify-content: center; background-color:white !important">
        @for (index of linesInfo; track index.name) {
          <div class="item primary-color"
            style="display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center;">
              @if (index.unitPrice>0) {
                <div>
                  {{ index.quantity.split('.',1) }} X {{ index.name }} {{ (index.unitPrice|currency:'EUR':'symbol':'1.2-2') + '/ud' }}
                </div>
              }
              @if (index.usesPrice>0) {
                <div>
                  {{ index.quantity.split('.',1) }} X {{ index.name }} {{ index.usesPrice|currency:'B':'symbol':'1.2-2'  }}/ud
                </div>
              }
          </div>
        }
      </div>
    }

    <!--RECARGA DE BONOS-->
    <!--<div class="payment-details-headers" style="width: 100%; display: flex; align-items: center; justify-content: center;">-->
    <!--<div class="light-16px-left-primary" style="width: 50%;">Bono</div>-->
    <!--<div class="light-16px-right-primary" style="width: 50%;">Cantidad</div>-->
    <!--</div>-->

    <!--<div class="payment-details-content-background primary-background-50" style="width: 100%; display: flex; flex-direction: row; flex-wrap: wrap;"-->
    <!--style="display: flex; align-items: flex-start; justify-content: center;"-->
    <!--[ngStyle]="{'height.px' : payment.vouchers * 40 + thereIsScroll * 20}">-->
    <!--&lt;!&ndash;ng for por cada bono usado o recargado&ndash;&gt;-->
    <!--<div class="payment-details-boucher" style="width: 100%; display: flex; align-items: center; justify-content: center;">-->
    <!--<div class="payment-details-boucher-name bold-400-18px-left-primary" style="width: 40%;">Happy Hour</div>-->
    <!--&lt;!&ndash;<div class="payment-details-boucher-quantity bold-400-18px-left-primary">6</div>&ndash;&gt;-->
    <!--<div class="payment-details-boucher-tokens" style="width: 60%;">-->
    <!--<div class="voucher-uses-row bold-400-18px-left-primary" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 14px;"-->
    <!--style="display: flex; align-items: center; justify-content: flex-end;">-->
    <!--6-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="payment-details-boucher" style="width: 100%; display: flex; align-items: center; justify-content: center;">-->
    <!--<div class="payment-details-boucher-name bold-400-18px-left-primary" style="width: 40%;">Plato de arroz</div>-->
    <!--&lt;!&ndash;<div class="payment-details-boucher-quantity bold-400-18px-left-primary">6</div>&ndash;&gt;-->
    <!--<div class="payment-details-boucher-tokens" style="width: 60%;">-->
    <!--<div class="voucher-uses-row bold-400-18px-left-primary" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 14px;"-->
    <!--style="display: flex; align-items: center; justify-content: flex-end;">-->
    <!--4-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->

    <!--<div class="regular-18px-center-primary close-dialog" style="width: 100%; display: flex; align-items: center; justify-content: center;"-->
    <!--(click)="onGoBack()">-->
    <!--Volver-->
    <!--</div>-->

    <!--</div>-->
  </div>
</div>
</div>
